// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"56":"967bc113","119":"967bc113","349":"967bc113","500":"967bc113","587":"967bc113","675":"967bc113","730":"967bc113","968":"967bc113"}[chunkId] + ".chunk.css";
};